import { lazy } from "react";

const routes = [
  {
    path: "/district",
    element: lazy(() => import("../pages/District")),
  },
  {
    path: "/district/add",
    element: lazy(() => import("../pages/District/create")),
  },
  {
    path: "/district/edit/:id",
    element: lazy(() => import("../pages/District/edit")),
  },
];

export default routes;
